<template>
    <el-option
        :label="label"
        :value="value">
        <slot><strong>{{ label }}</strong></slot>
    </el-option>
</template>

<script setup>
defineProps({
    value: {
        required: true
    },
    label: {
        type: [String, Number]
    }
})
</script>

<style scoped>

</style>